import { Icon, SimpleGrid } from '@chakra-ui/react';
import numeral from '@lib/numeral';
import IconStatClicked from 'assets/icons/icon-stat-clicked.svg?react';
import IconStatDelivered from 'assets/icons/icon-stat-delivered.svg?react';
import IconStatDropped from 'assets/icons/icon-stat-dropped.svg?react';
import IconStatOpened from 'assets/icons/icon-stat-opened.svg?react';
import IconStatSent from 'assets/icons/icon-stat-sent.svg?react';
import { useFormContext } from 'react-hook-form';
import { useAnalyticsMetrics } from '../hooks/useAnalyticsMetrics';
import MetricCard from './MetricCard';

export default function MetricStatCards() {
  const { watch } = useFormContext();
  const [company, dateRange, lists, emailCategory, contentGroups] = watch([
    'company',
    'dateRange',
    'lists',
    'emailCategory',
    'contentGroups',
  ]);

  let params: Record<string, unknown> = { dateRange };

  if (company) {
    params = { ...params, companyId: company.value };
  }

  if (lists) {
    params = { ...params, listIds: lists.map((l) => l.value) };
  }

  if (emailCategory) {
    params = { ...params, emailCategory: emailCategory.value };
  }

  if (contentGroups) {
    params = { ...params, contentGroupIds: contentGroups.map((c) => c.value) };
  }

  const { data: metrics, isLoading } = useAnalyticsMetrics(params);

  return (
    <>
      <SimpleGrid
        columns={{ base: 1, md: 2, lg: 3, '2xl': 5 }}
        columnGap="24px"
        rowGap="24px"
        mt="53px"
      >
        <MetricCard
          isLoading={isLoading}
          title="Volume enviado no período"
          icon={<Icon as={IconStatSent} />}
          label="Emails enviados"
          value={numeral(metrics?.Send?.count).format('0,0')}
        />

        <MetricCard
          isLoading={isLoading}
          title="Taxa de entrega"
          icon={<Icon as={IconStatDelivered} />}
          label={`${numeral(metrics?.Delivery?.count).format('0,0')} emails`}
          value={numeral(metrics?.Delivery?.rate).format('0.00%')}
        />

        <MetricCard
          isLoading={isLoading}
          title="Taxa de abertura"
          icon={<Icon as={IconStatOpened} />}
          label={`${numeral(metrics?.Open?.count).format('0,0')} emails`}
          value={numeral(metrics?.Open?.rate).format('0.00%')}
        />

        <MetricCard
          isLoading={isLoading}
          title="Taxa de clique"
          icon={<Icon as={IconStatClicked} />}
          label={`${numeral(metrics?.Click?.count).format('0,0')} emails`}
          value={numeral(metrics?.Click?.rate).format('0.00%')}
        />

        <MetricCard
          isLoading={isLoading}
          title="Taxa de devoluções (bounce)"
          icon={<Icon as={IconStatDropped} />}
          label={`${numeral(metrics?.Bounce?.permanent).format('0,0')} emails`}
          value={numeral(
            metrics?.Bounce?.permanent / metrics?.Send?.count || 0
          ).format('0.00%')}
        />
      </SimpleGrid>
    </>
  );
}
